module.exports = __webpack_public_path__ + "media/payment_methods/visa-f2064830.svg";